import React from "react";
import {
  FaLaptopCode,
  FaMobileAlt,
  FaPaintBrush,
  FaCloud,
  FaDatabase,
  FaHandsHelping,
} from "react-icons/fa";
import ServicesIllustration from "../assets/services-image.svg"; // your selected image

const iconClass = "text-white w-5 h-5";

const services = [
  {
    title: "Web Applications",
    description: "Custom web apps built for scale, speed, and security.",
    icon: <FaLaptopCode className={iconClass} />,
  },
  {
    title: "Mobile Applications",
    description: "Cross-platform and native apps tailored to your growth.",
    icon: <FaMobileAlt className={iconClass} />,
  },
  {
    title: "UI/UX Design",
    description: "Crafting intuitive and elegant interfaces for every device.",
    icon: <FaPaintBrush className={iconClass} />,
  },
  {
    title: "Cloud & DevOps",
    description: "CI/CD pipelines, infra setup, and automation made easy.",
    icon: <FaCloud className={iconClass} />,
  },
  {
    title: "Backend Systems",
    description: "Robust APIs and scalable backend architectures.",
    icon: <FaDatabase className={iconClass} />,
  },
  {
    title: "Consulting & Support",
    description: "Tech guidance and long-term support to scale confidently.",
    icon: <FaHandsHelping className={iconClass} />,
  },
];

const ServicesSection = () => {
  return (
    <section id="services" className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
        {/* Left Illustration */}
        <div className="hidden md:block">
          <img
            src={ServicesIllustration}
            alt="Services Illustration"
            className="w-full h-auto"
          />
        </div>

        {/* Right Content */}
        <div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Services</h2>
          <p className="text-gray-600 mb-10">
            We offer end-to-end solutions tailored to meet your digital goals.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-lg p-4 flex items-start space-x-4 hover:shadow-md transition-all"
              >
                <div className="bg-[#4C47DC] p-2 rounded-full">{service.icon}</div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-900 mb-1">
                    {service.title}
                  </h3>
                  <p className="text-sm text-gray-600">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
